import { TRIP_INFORMATION_SET_FLEXIBILITY } from './flexibility.constants';
type State = number;
const initialState = null;
export function flexibilityReducer(
  state: State | null | undefined = initialState,
  { type, payload }: Action<any>,
): State | null | undefined {
  switch (type) {
    case TRIP_INFORMATION_SET_FLEXIBILITY:
      return payload.value;

    default:
      return state;
  }
}
